module.exports = __webpack_public_path__ + "images/img-mobile.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/img-mobile.png
 ** module id = 2443
 ** module chunks = 3
 **/